export const RETAILER_PROFILE = {
    PAGE: "retailer-profile-page",
    CONTAINERS: {
        ADDRESS_LINE_1: "retailer-profile-address-line-1",
        ADDRESS_LINE_2: "retailer-profile-address-line-2",
        CITY: "retailer-profile-city",
        STATE: "retailer-profile-state",
        ZIP: "retailer-profile-zip",
        COUNTRY: "retailer-profile-country",
    },
    INPUTS: {
        ADDRESS_LINE_1: "retailer-profile-address-line-1-input",
        ADDRESS_LINE_2: "retailer-profile-address-line-2-input",
        CITY: "retailer-profile-city-input",
        STATE: "retailer-profile-state-input",
        ZIP: "retailer-profile-zip-input",
        COUNTRY: "retailer-profile-country-input",
    },
    CONTINUE_BUTTON: "retailer-profile-address-continue-button",
    NO_OPTIONS_MESSAGE: "retailer-profile-address-line-1-no-options-message",
};
